import React, { useEffect, useContext, forwardRef } from "react"
import styled from "styled-components"
import { navigate } from "gatsby";


import ContainerLayout from "../../components/ui/containerLayout"
import BottomImagesBlock from "../../components/bottomBlockImages"

import { LocaleContext, useI18n, useCustomI18n } from "../../../locale.js"

import slashedGreyCubes from "../../assets/images/elements/slashedGreyCubes.svg"
import greyCubes from "../../assets/images/elements/greyCubesCloud.png"
import { I18nextContext } from "gatsby-plugin-react-i18next";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const Booking = forwardRef(({ city }, ref) => {
  const { locale } = useContext(LocaleContext)
  const context = React.useContext(I18nextContext);
  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    window.bookingServiceId = city.bookingServiceId
    window.bookingWidgetTheme = "green"
    window.bookingWidgetSuccessFn = () => {
      // Ping GTM
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ 'event': 'formsendVR' })
      // Go to Thank You page
      navigate(`/${city.slug}/thank-you`)
    }

    setTimeout(() => {
      // if (process.env.NODE_ENV !== "development") {
      const headID = document.getElementsByTagName("head")[0]
      const newScript = document.createElement("link")
      newScript.type = "text/css"
      newScript.rel = "stylesheet"
      newScript.href =
        "https://storage.googleapis.com/booking-widget/static/css/main.css"
      headID.appendChild(newScript)

      const newScript2 = document.createElement("script")
      newScript2.type = "text/javascript"
      newScript2.src =
        "https://storage.googleapis.com/booking-widget/static/js/main.js"
      headID.appendChild(newScript2)
      // }
      const calendarContainer = document.getElementById('calendar_container')
    }, 500)
  }, [city.bookingServiceId])

  useEffect(() => {
    window.bookingWidgetLang = context.language
  }, [context.language])

  return (
    
    <WrapStyled ref={ref}>
      <ContainerLayoutStyled id="booking">
        <TitleStyled>
          <span>
            <b>{useI18n("main.booking.title")}</b>
          </span>{" "}
          {useI18n("main.booking.time")} <br />
          {useI18n("main.booking.gameIn")} <b>{useCustomI18n(city.declension)}</b>{" "}
          {useI18n("main.booking.rightNow")}
        </TitleStyled>
          <CalendarWrapStyled>
            <div id="calendar_container" />
          </CalendarWrapStyled>
        <BottomImagesBlock />
      </ContainerLayoutStyled>
    </WrapStyled>
  )
})

export default Booking

const WrapStyled = styled.div`
  overflow: hidden;
`

const ContainerLayoutStyled = styled(ContainerLayout)`
  position: relative;
  padding-bottom: 0;

  &:before {
    content: "";
    width: 170px;
    height: 28px;
    position: absolute;
    left: 0%;
    top: 8%;

    background-image: url(${slashedGreyCubes});
    background-size: 80%;
    background-repeat: no-repeat;
  }

  &:after {
    content: "";

    width: 250px;
    height: 380px;

    position: absolute;
    top: 0;
    right: -12%;

    background-image: url(${greyCubes});
    background-size: 80%;
    background-repeat: no-repeat;
    background-position: right top;
  }

  @media ${props => props.theme.breakpoints.small} {
    &:before,
    &:after {
      display: none;
    }
  }
`
const TitleStyled = styled.p`
  max-width: 50%;
  margin-bottom: 100px;

  font-size: 2.5rem;
  line-height: 1.14;
  text-align: center;
  z-index: 1;

  span {
    color: ${props => props.theme.colors.green};
  }
  br {
    display: none;
  }
  @media ${props => props.theme.breakpoints.tablet} {
    max-width: 100%;

    br {
      display: block;
    }
  }

  @media ${props => props.theme.breakpoints.small} {
    font-size: 1.7rem;
  }
`

const CalendarWrapStyled = styled.div`
  @media ${props => props.theme.breakpoints.mobile} {
    width: calc(100% + 2rem);
  }
`
